import { useQuery } from '@tanstack/react-query';
import { EmailProblemsApi } from '../../../apis/EmailProblemsApi/EmailProblemsApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';

export const useGetEmailProblems = () => {
    return useQuery({
        queryKey: [QueryKeys.emailProblems],
        queryFn: () => EmailProblemsApi.getEmailProblems(),
    });
}; 